export const IconTypes = {
  Summary: "Summary",
  Warning: "Warning",
  Bid: "Bid"
};
